
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-06-22-r3f-viewcube",
      function () {
        return require("private-next-pages/blogs/2025-06-22-r3f-viewcube/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-06-22-r3f-viewcube"])
      });
    }
  